<template>
  <div>
    <div class="row upload-via-link">
      <div class="col-12">
        <div v-if="uploadErrorMessage">
          <div class="mt-3 alert alert-danger text-wrap">
            {{ uploadErrorMessage }}
          </div>
        </div>
        <div class="pt-3 d-flex align-items-end justify-content-between">
          <div class="flex-fill pr-3">
            <validated-input
              placeholder="https://example.com/image/123.jpg"
              v-model="link"
              :disabled="isLoading"
              :prependIcon="hasSpinner && isLoading ? 'spin fa-spinner-third far' : null"
              name="link"
              :validate="validate"
              class="w-100 pb-0"
              @paste="checkChangeLink"
              @change="checkChangeLink"
              label="Upload from URL"
            />
          </div>
          <div v-if="hasUploadBtn" class="form-group pb-1">
            <button
              class="btn btn-primary d-flex align-items-center justify-content-center"
              :disabled="isLoading || !link"
              @click="onChangeLink"
            >
              Upload
              <div v-if="isLoading">
                <i class="far fa-spinner-third fa-spin fa-1x"></i>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="ml-n2">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import HTTP from '@/utils/http-common';

export default {
  name: 'UploadArtworksList',
  props: {
    folder: {
      type: String
    },
    resize: {
      type: [Number, String]
    },
    compress: {
      type: Boolean
    },
    toUploadModel: {
      type: Boolean
    },
    uploadToStoreMedia: {
      type: Boolean
    },
    hasLabel: {
      type: Boolean,
      default: true
    },
    hasUploadBtn: {
      type: Boolean,
      default: false
    },
    hasSpinner: {
      type: Boolean,
      default: false
    },
    allowChangeLinkEvent: {
      type: Boolean,
      default: false
    },
    validate: {
      type: Object,
      default: () => ({ url: true })
    }
  },
  inject: ['$validator'],
  data() {
    return {
      isLoading: false,
      link: '',
      uploadErrorMessage: null
    };
  },
  methods: {
    checkChangeLink() {
      if ((this.allowChangeLinkEvent || !this.hasUploadBtn) && this.link && !this.isLoading) {
        this.onChangeLink();
      }
    },
    async onChangeLink() {
      await this.$validator.validateAll();

      if (this.errors.any()) {
        return;
      }

      try {
        this.isLoading = true;
        this.uploadErrorMessage = null;
        const bucketToSave = this.folder ? `${this.folder}/` : null;
        const body = {
          url: this.link,
          resize: this.resize,
          compress: this.compress,
          toUploadModel: this.toUploadModel,
          storeMedia: this.uploadToStoreMedia,
          bucketToSave
        };
        if (this.$parent.type) body.mediaType = this.$parent.type;
        const { file } = (await HTTP.post('/upload/from-link', body)).data;
        if (file) {
          this.$emit('select', Object.assign({}, file, { alreadyLoaded: true }));
        }
        this.link = '';
        this.$nextTick(() => this.$validator.reset());
      } catch (e) {
        const { message } = e.data || (e.response && e.response.data) || {};
        this.uploadErrorMessage = message || 'Failed load image';
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
